import { createFileRoute, redirect } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"

export const Route = createFileRoute("/orders")({
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) throw redirect({ to: "/login" })
  },
})
